// extracted by mini-css-extract-plugin
export var item = "grid-module--item--f0eee";
export var itemContent = "grid-module--itemContent--83733";
export var main = "grid-module--main--9f664";